import React from 'react';
import { NetWorthContent } from './NetWorthStyles';
import { NetWorthChartLoading } from './NetWorthChart/NetWorthChartLoading';
import { NetWorthTableLoading } from './NetWorthTable/NetWorthTableLoading';
import { Text } from '../../CommonComponents/OPL/Text/Text';
import { NETWORTH_DESCRIPTION } from './NetWorth.meta';

export const NetWorthLoading = () => {
  return (
    <>
      <Text as="p" fontSize="h6" mt="12">
        {NETWORTH_DESCRIPTION}
      </Text>
      <NetWorthContent>
        <NetWorthChartLoading />
        <NetWorthTableLoading />
      </NetWorthContent>
    </>
  );
};
